/**
 * GET_FEATURES (modulos com `childs`) -> opcoes do feature-module-picker.
 *
 * O valor e o ID DO BANCO da funcionalidade, que e o que a venda e o boleto
 * gravam. A Liberacao usa o mesmo seletor com o enum; os dois nunca se
 * misturam. So os seis modulos que este modal sempre mostrou entram, na mesma
 * ordem — o resto da resposta continua fora, como antes.
 */
export const FEATURE_MODULES = [
  'Controle de Jornada',
  'Departamento Pessoal',
  'Desenvolvimento de Pessoas',
  'Comunicação e Cultura',
  'Benefícios Corporativos',
  'Funcionalidades extras',
];

/**
 * Rotulo na tela quando difere do nome da v1: a Liberacao chama o ultimo
 * modulo de "Extras", e o operador ve o mesmo nome nas duas telas.
 */
const MODULE_LABELS = { 'Funcionalidades extras': 'Extras' };

const featuresOf =(modules, name) => {
  const found = (modules || []).find((module) => module && module.name === name);
  return ((found && found.childs) || []).filter((feature) => feature && feature.name !== null);
};

export const toPickerOptions = (modules) => {
  const options = [];
  const seen = {};
  FEATURE_MODULES.forEach((name, moduleOrder) => {
    featuresOf(modules, name).forEach((feature, order) => {
      if (seen[feature.id]) return;
      seen[feature.id] = true;
      options.push({
        value: feature.id, label: feature.name, module: MODULE_LABELS[name] || name,
        moduleOrder, order, notes: feature.tooltip || '',
      });
    });
  });
  return options;
};

export const enabledIds = (modules) => {
  const ids = [];
  FEATURE_MODULES.forEach((name) => {
    featuresOf(modules, name).forEach((feature) => {
      if (feature.enabled && ids.indexOf(feature.id) === -1) ids.push(feature.id);
    });
  });
  return ids;
};



// WEBPACK FOOTER //
// ./src/vue/pages/modals/featureOptions.js